module.exports = __webpack_public_path__ + "img/huaihua.7d0b90fe.jpg";